import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=581cbeb7&scoped=true"
import script from "./ButtonBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=581cbeb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_babel-core@7.0.0-bridge.0_@babel+core@7.29._ce6ff47a1f7c1545485218f930d01bd2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581cbeb7",
  null
  
)

export default component.exports